import { useNavigate } from 'react-router-dom';
import { getCoverImageUrl } from '@utils/helpers';
import { isMobile } from '@utils/helpers';

function DramaModal({ drama, isOpen, onClose }) {
    const navigate = useNavigate();

    if (!isOpen || !drama) return null;

    const handleWatchNow = () => {
        const mobile = isMobile() ? '&mobile=1' : '';
        navigate(`/player?bookId=${drama.id || drama.bookId}&title=${encodeURIComponent(drama.name || drama.bookName)}${mobile}`);
        onClose();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className={`modal-overlay ${isOpen ? 'active' : ''}`} onClick={handleOverlayClick}>
            <div className="drama-modal">
                <button className="modal-close" onClick={onClose}>
                    <i className="fas fa-times"></i>
                </button>

                <div className="modal-content">
                    <div className="modal-poster">
                        <img
                            src={getCoverImageUrl(drama)}
                            alt={drama.name || drama.bookName}
                            onError={(e) => e.target.style.display = 'none'}
                        />
                        <div className="play-overlay" onClick={handleWatchNow}>
                            <i className="fas fa-play"></i>
                            <span>Mulai Menonton</span>
                        </div>
                    </div>

                    <div className="modal-info">
                        <h2>{drama.name || drama.bookName}</h2>
                        <div className="modal-meta">
                            <span className="episode-count">
                                {drama.chapterCount || 0} Episode
                            </span>
                            <span className="subtitle-info">Sub: Indonesia</span>
                        </div>

                        <div className="tags">
                            {drama.tags && drama.tags.length > 0 ? (
                                drama.tags.slice(0, 5).map((tag, index) => (
                                    <span key={index} className="tag">
                                        {typeof tag === 'string' ? tag : tag.tagName}
                                    </span>
                                ))
                            ) : drama.tagV3s && drama.tagV3s.length > 0 ? (
                                drama.tagV3s.slice(0, 5).map((tag, index) => (
                                    <span key={index} className="tag">
                                        {tag.tagName}
                                    </span>
                                ))
                            ) : null}
                        </div>

                        <p className="description">
                            {drama.introduction || 'Deskripsi tidak tersedia.'}
                        </p>

                        <div className="action-buttons">
                            <button className="watch-btn" onClick={handleWatchNow}>
                                <i className="fas fa-play"></i>
                                Tonton Sekarang
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DramaModal;
